export const ALLOWLIST_URLS = [
  'https://global-devel.renaissance-golabs.com/educatorportal/',
  'https://global-zone05.renaissance-go.com/educatorportal/',
  'https://global-zone08.renaissance-go.com/educatorportal/',
  'https://global-zone20.renaissance-go.com/educatorportal/',
  'https://global-zone50.renaissance-go.com/educatorportal/',
  'https://global-zone51.renaissance-go.com/educatorportal/',
  'https://global-zone52.renaissance-go.com/educatorportal/',
  'https://global-zone53.renaissance-go.com/educatorportal/',
  'https://global-zone60.renaissance-go.com/educatorportal/',
  'https://global-zone61.renaissance-go.com/educatorportal/',
  'https://global-zone99.renaissance-go.com/educatorportal/',
  'https://global-zone98.renaissance-goprestage.com/educatorportal/'
];

export const DEFAULT_REDIRECT_URL = 'https://schools.renaissance.com';
